import { sendData, setCookie } from "../../utils.js";

export function logout() {
    const logoutBtn = document.querySelector('.__logout_btn');
    if(!logoutBtn) return;
    logoutBtn.addEventListener('click',()=>{
        logoutFunc();
    });
}

export function logoutFunc() {
    const body = {};
    
    sendData(body, '/api/logout/')
    .then(res=>{
        setCookie('access_token', '',{'max-age': -1});
        setCookie('refresh_token', '',{'max-age': -1});
        setCookie('expire_date', '',{'max-age': -1});

        try {
            sessionStorage.removeItem('cdek_selected_addresses');
            sessionStorage.removeItem('personal_delivery_addresses');
        } catch (e) {}

        setTimeout(() => {
            window.location.href = '/';
        }, 100);
    });
}

// Проверяй кол-во товаров в админке, при переносе в заказ товар резервируется и пропадает с сайта